var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuv = function SvgSuv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.913 13.665c-1.796.898-4.508 4.933-6.08 7.997a6.9 6.9 0 0 0-.76 2.65 30.3 30.3 0 0 0 .154 5.81c.412 3.292 3.943 4.458 5.657 4.629h53.487c1.029 0 3.086-1.543 3.6-2.572.326-.65 1.029-2.571 1.029-4.628s-.514-2.572-2.057-3.6c-.795-.53-3.983-1.114-6.616-1.686a10.8 10.8 0 0 1-3.05-1.19c-3.942-2.242-10.25-5.796-11.42-6.382-1.029-.514-4.115-1.028-5.658-1.028-9.257-.514-26.39-.948-28.286 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0BDF4",
    d: "m51.598 22.408-27.258-.514-15.43-.514c-.514-1.03.25-4.805 2.572-5.366 3.514-.39 23.975-.39 27.49 0a5.6 5.6 0 0 1 1.479.53c1.637.938 9.617 4.759 11.146 5.864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m35.398 22.408-7.972-.242m14.529.5 9.643.256-1.543-1.028c-2.572-1.543-3.856-2.443-7.2-4.115-1.642-.82-2.73-1.37-6.172-1.543-9.48-.474-15.901-.51-24.096-.111a3.93 3.93 0 0 0-3.21 1.954 44 44 0 0 0-.98 1.757c-.412.823.514 2.058 1.543 2.058l9.771.272M30.516 16.75l1.028 5.143"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.657,
    cy: 32.694,
    r: 4.907,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.571,
    cy: 32.694,
    r: 4.907,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M55.716 32.694a2.057 2.057 0 1 1-4.114 0 2.057 2.057 0 0 1 4.114 0M16.63 32.694a2.057 2.057 0 1 1-4.114 0 2.057 2.057 0 0 1 4.114 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.17 16.75-1.03 5.143"
  })));
};
export default SvgSuv;